export default {
    buildDate: 1718497740457,
    release: 35,
}